export default __webpack_public_path__ + "static/media/noteEnabled.4430d6c3.svg";